<div id="SL22" class="block lilac_deep">
    <div class="cage">
        <div data-aos="fade-up">
            <h1 class="ct-start-2-4 ctr-start-1-6 headline_01_xl_light flex-center-v title">{{package.title000 | uppercase}}</h1>
            <p class="body_02_xl_regular text" [innerHTML]="package.text001">
            </p>
            <p class="body_02_xl_regular text" [innerHTML]="package.text002">
            </p>
            <button (click)="emitLink(package.buttonLink)"  class="button">{{package.button001 | uppercase}}</button>
        </div>
        <div (click)="emitLink(package.buttonLink)" style="display: inline-flex" class="weare">
            <img [src]="package.imagine" alt="" />
        </div>
    </div>
</div>